import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "alternateglyphforms"
    }}>{`AlternateGlyphForms`}</h1>
    <p>{`Glyph variant substitution options for standard glyphs.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NONE`}</strong>{` = 1852796517`}</p>
      <p parentName="blockquote">{`Does not use an alternate form.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TRADITIONAL_FORM`}</strong>{` = 1247897460`}</p>
      <p parentName="blockquote">{`Uses the traditional variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`EXPERT_FORM`}</strong>{` = 1247897445`}</p>
      <p parentName="blockquote">{`Uses the expert variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`JIS78_FORM`}</strong>{` = 1247897399`}</p>
      <p parentName="blockquote">{`Uses the JIS78 variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`JIS83_FORM`}</strong>{` = 1247897400`}</p>
      <p parentName="blockquote">{`Uses the JIS83 variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MONOSPACED_HALF_WIDTH_FORM`}</strong>{` = 1247897453`}</p>
      <p parentName="blockquote">{`Uses the monospaced half-width variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`THIRD_WIDTH_FORM`}</strong>{` = 1247897448`}</p>
      <p parentName="blockquote">{`Uses the third-width variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`QUARTER_WIDTH_FORM`}</strong>{` = 1247897457`}</p>
      <p parentName="blockquote">{`Uses the quarter-width variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NLC_FORM`}</strong>{` = 1247897454`}</p>
      <p parentName="blockquote">{`Uses the NLC variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PROPORTIONAL_WIDTH_FORM`}</strong>{` = 1247897456`}</p>
      <p parentName="blockquote">{`Substitutes proportional glyphs for half-width and full-width glyphs.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FULL_WIDTH_FORM`}</strong>{` = 1247897446`}</p>
      <p parentName="blockquote">{`Uses the full-width variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`JIS04_FORM`}</strong>{` = 1247897396`}</p>
      <p parentName="blockquote">{`Uses the JIS04 variant.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`JIS90_FORM`}</strong>{` = 1247897401`}</p>
      <p parentName="blockquote">{`Uses the JIS90 variant.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      